import { Component } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';

/** Renders the global toast stack (top of the viewport). */
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent {
  constructor(public toasts: ToastService) {}

  icon(type: string): string {
    return type === 'error' ? 'fa-exclamation-circle'
         : type === 'success' ? 'fa-check-circle'
         : 'fa-info-circle';
  }
}
